(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import PropTypes from 'prop-types';
function ImageWebp({
  src,
  mobilesrc,
  webp,
  classNamePictureTag,
  type = 'image/webp',
  ...delegated
}) {
  let webpSrc = webp;
  let webpSrcMobile = webp;
  let mobilePic;
  if (!webp) {
    webpSrc = src.replace(/\.(jpe?g|png)/i, '.webp');
  }
  if (mobilesrc != undefined) {
    webpSrcMobile = mobilesrc.replace(/\.(jpe?g|png)/i, '.webp');
    mobilePic = /*#__PURE__*/React.createElement("source", {
      media: "(max-width: 480px)",
      srcSet: webpSrcMobile,
      type: type
    });
  }
  return /*#__PURE__*/React.createElement("picture", {
    className: classNamePictureTag
  }, mobilePic, /*#__PURE__*/React.createElement("source", {
    srcSet: webpSrc,
    type: type
  }), /*#__PURE__*/React.createElement("img", _extends({
    src: src
  }, delegated)));
}
ImageWebp.propTypes = {
  src: PropTypes.string,
  mobilesrc: PropTypes.string,
  webp: PropTypes.string,
  type: PropTypes.string
};
const _default = ImageWebp;
export default _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(ImageWebp, "ImageWebp", "/var/www/html/websites/livecbm-com/src/frontend/components/custom/ImageWebp.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/livecbm-com/src/frontend/components/custom/ImageWebp.jsx");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();